document.addEventListener("DOMContentLoaded", () => {
  // Crea il layer di caricamento
  const loadingLayer = document.createElement('div')
  loadingLayer.id = 'loading-layer'
  loadingLayer.className = 'loading-layer'
  loadingLayer.innerHTML = '<div class="loading-icon"></div>'
  document.body.appendChild(loadingLayer)

  // Funzioni per mostrare e nascondere il layer di caricamento
  const showLoadingLayer = () => {
    document.getElementById('loading-layer').style.display = 'flex'
  }

  const hideLoadingLayer = () => {
    document.getElementById('loading-layer').style.display = 'none'
  }

  // Aggiungi il CSS per il layer di caricamento
  const style = document.createElement('style')
  style.innerHTML = `
    .loading-layer {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.4);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      display: none /* Nascondi il layer di caricamento per impostazione predefinita */;
    }

    .loading-icon {
      border: 16px solid #f3f3f3;
      border-radius: 50%;
      border-top: 16px solid #8a8a8a;
      width: 120px;
      height: 120px;
      animation: spin 2s linear infinite;
    }

    @keyframes spin {
      0% { transform: rotate(0deg) }
      100% { transform: rotate(360deg) }
    }
  `
  document.head.appendChild(style)

  // Funzione per verificare se un input ha un valore maggiore di zero
  const hasValueGreaterThanZero = (numberInputs) => {
    for (let input of numberInputs) {
      if (parseFloat(input.value) > 0) {
        return true
      }
    }
    return false
  }

  let amv = document.querySelectorAll('.add-multiple-variants')
  if (amv.length > 0) {
    /* LISTENER SU PULSANTI AGGIUNGI / RIMIOVI */
    document.addEventListener("click", async function(event) {
      if (event.target.classList.contains("showCartPanel")) {
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }))
        let showCartPanel = event.target
        let lineItems = showCartPanel.closest("fieldset").querySelectorAll(".line-item-quantity")
        let iter = 0
        if (showCartPanel.classList.contains("removeAll")) {
          for (let lineItem of lineItems) {
            lineItem.querySelector("input").value = 0
            lineItem.querySelector(".quantity-selector").querySelector(".minus").setAttribute("invisible", "")
            if (parseInt(lineItem.querySelector("input").getAttribute("max"), 10) > 0) {
              lineItem.querySelector(".quantity-selector").querySelector(".plus").removeAttribute("invisible")
            }
          }
        }
        for (let lineItem of lineItems) {
          iter++
          const qty = parseInt(lineItem.querySelector("input").value, 10)
          let response = {}
          const cartDrawerItems = document.querySelector(".cart-drawer__items");
          if (cartDrawerItems && cartDrawerItems.querySelector('[data-line-item_key="'+lineItem.dataset.variant_id+'"]')) {
            response = await fetch(`${Shopify.routes.root}cart/change?id=${lineItem.dataset.variant_id}&quantity=${qty}`)
          } else {
            if (qty > 0) {
              response = await fetch(`${Shopify.routes.root}cart/add?id=${lineItem.dataset.variant_id}&quantity=${qty}`)
            }
          }
          if (response.ok) {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {bubbles: true }))
            let showCartPanelButtonFieldset = lineItem.closest("fieldset")
            const numberInputs = showCartPanelButtonFieldset.querySelectorAll('input[type="number"]')
            if (hasValueGreaterThanZero(numberInputs)) {
              showCartPanelButtonFieldset.querySelector(".showCartPanel").classList.remove("disabled")
            } else {
              showCartPanelButtonFieldset.querySelector(".showCartPanel").classList.add("disabled")
            }
          }
          if (lineItems.length == iter) {
            document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }))
          }
        }
        document.querySelector("[aria-controls='cart-drawer']").click()
      }
    })

    /* LISTENER SU PULSANTI + e - */
    document.addEventListener("click", function(event) {
      let quantitySelector__button
      if (event.target.closest(".b2b_quantity-selector__button_icon")) {
        quantitySelector__button = event.target.closest(".b2b_quantity-selector__button_icon")
      } else if (event.target.classList.contains("b2b_quantity-selector__button_icon")) {
        quantitySelector__button = event.target
      }
      if (quantitySelector__button) {
        event.stopPropagation()
        event.preventDefault()
        let quantitySelector__input = quantitySelector__button.closest(".quantity-selector").querySelector(".quantity-selector__input")
        let maxQty = parseInt(quantitySelector__input.getAttribute("max"))
        let qty = parseInt(quantitySelector__input.value, 10)
        if (quantitySelector__button.classList.contains("plus")) {
          qty++
        } else if (quantitySelector__button.classList.contains("minus")) {
          qty--
        }
        if (qty == 0) {
          quantitySelector__input.value = 0
          quantitySelector__button.closest(".quantity-selector").querySelector(".minus").setAttribute("invisible", "")
          quantitySelector__button.closest(".quantity-selector").querySelector(".plus").removeAttribute("invisible")
        } else if (qty < maxQty) {
          quantitySelector__input.value = qty
          quantitySelector__button.closest(".quantity-selector").querySelector(".minus").removeAttribute("invisible")
          quantitySelector__button.closest(".quantity-selector").querySelector(".plus").removeAttribute("invisible")
        } else if (qty >= maxQty) {
          quantitySelector__input.value = maxQty
          quantitySelector__button.closest(".quantity-selector").querySelector(".minus").removeAttribute("invisible")
          quantitySelector__button.closest(".quantity-selector").querySelector(".plus").setAttribute("invisible", "")
        }
      }
    })

    /* LISTENER SU RIMUOVI DA PANNELLO CARRELLO */
    document.addEventListener("click", async function(event) {
      if (event.target.classList.contains("remove-item") && event.target.closest(".cart-drawer__items")) {
        let lineItemKey = event.target.closest(".line-item").getAttribute("data-line-item_key")
        let lineItem = document.querySelector(".product-list").querySelector(".line-item[data-line-item_key='"+lineItemKey+"']")
        lineItem.querySelector("input").value = 0
        lineItem.querySelector(".quantity-selector").querySelector(".minus").setAttribute("invisible", "")
        if (parseInt(lineItem.querySelector("input").getAttribute("max"), 10) > 0) {
          lineItem.querySelector(".quantity-selector").querySelector(".plus").removeAttribute("invisible")
        }
      }
    })

    document.addEventListener("theme:loading:start", (e) => {
      showLoadingLayer()
    })

    document.addEventListener("theme:loading:end", (e) => {
      hideLoadingLayer()
    })
  }
})